import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { InfoCircle } from '../../assets/icons/index';

export type InfoBladeProps = { className?: string; text: string };

export const InfoBlade: FC<InfoBladeProps> = ({ text, className }) => (
  <div className={twMerge('flex gap-2 rounded-[4px] bg-brand-25 p-4', className)}>
    <InfoCircle className="size-4" iconColor="#2565C8" />
    <span className="text-nowrap text-xs text-gray-600">{text}</span>
  </div>
);
